export default __webpack_public_path__ + "static/media/download-iphone.86735414.png";